import { useB2C } from '@zet/common/hooks/useB2C'
import { isAgentDetailsWFQueryEnabled, useAgentDetailsWF } from '@zet/customer'
import { useExperiments } from '@zet/experiments'

export const useRecommendationFlow = () => {
  const { data: experiments, isLoading: isExperimentsLoading } =
    useExperiments()

  const { isNavigationReady } = useB2C()

  // React query is only enabled for web
  const { data, isLoading } = useAgentDetailsWF()

  const isAgentDetailsWFLoading = isLoading && isAgentDetailsWFQueryEnabled

  const isNewRecommendationFlow = true
  // Platform.OS === 'web' && data?.variantId === null
  //   ? false
  //   : experiments?.UI_BrandRecommendationV2

  return {
    isNewRecommendationFlow,
    isNavigationReady,
    isLoading: isExperimentsLoading || isAgentDetailsWFLoading,
  }
}
